<template>
  <div class="content">
    <ToneIntroSection />
    <ToneGridSection />
    <ToneParagraphsSection />
  
  </div>
</template>

<script lang="ts">
import ToneParagraphsSection from '@/components/VerbalIdentityPage/sections/tone/ToneParagraphsSection.vue';
import ToneGridSection from '@/components/VerbalIdentityPage/sections/tone/ToneGridSection.vue';
import ToneIntroSection from '@/components/VerbalIdentityPage/sections/tone/ToneIntroSection.vue';
import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {    
    ToneIntroSection,
    ToneGridSection,
    ToneParagraphsSection

  }
})
export default class ToneView extends Vue {}
</script>

<style lang="scss"></style>
